var map = {
	"./bronze-transition-crown.svg": 69358,
	"./diamond-transition-crown.svg": 7618,
	"./gold-transition-crown.svg": 85872,
	"./platinum-transition-crown.svg": 50974,
	"./silver-transition-crown.svg": 74511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84447;